import React from "react";
import { Container, Row } from "../Grid";
import pureProps, { deepMergeProps } from "../utils/pureProps";
import { utilityProps } from "../props/utility";
import { spacingProps } from "../props/spacing";

const MegaMenu = ({
	utility = { ...utilityProps },
	spacing = { ...spacingProps },
	children,
	...props
}) => {
	return (
		<Container>
			<Row
				mx
				my
				utility={deepMergeProps({ justify: "center" }, pureProps(utility))}
				spacing={deepMergeProps({ py: 3 }, pureProps(spacing))}
				{...props}
			>
				{children}
			</Row>
		</Container>
	);
};

MegaMenu.propTypes = {
	...Row.propTypes,
};

export default MegaMenu;
